var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 278.6 45.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.67.54C29.78,15.43,14.89,30.32,0,45.21V.54h44.67Z",
    fill: "#57aeed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,45.21c14.89-4.85,29.78-9.71,44.67-14.56l-14.75,14.56H0Z",
    fill: "#57aeed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.33,0h27.22v8.97h-17.77v9.01h16.42v8.99h-16.42v17.97h-9.46V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.72,12.8h9.08v32.13h-9.08V12.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.25,9.07h0c2.51,0,4.54-2.03,4.54-4.54h0c0-2.51-2.03-4.54-4.54-4.54h0c-2.51,0-4.54,2.03-4.54,4.54h0c0,2.51,2.03,4.54,4.54,4.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.15.04h9.08v44.89h-9.08V.04Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.59,9.01h9.08v6.92h.19c1.18-2.4,2.84-4.21,4.98-5.45,2.14-1.24,4.64-1.86,7.5-1.86,3.15,0,5.86.78,8.13,2.33,2.27,1.56,3.89,3.8,4.85,6.75h.19c.97-2.86,2.65-5.09,5.04-6.68,2.4-1.6,5.23-2.4,8.51-2.4,2.14,0,4.09.36,5.83,1.07,1.74.72,3.22,1.76,4.44,3.12,1.22,1.37,2.15,3.02,2.81,4.95.65,1.93.98,4.1.98,6.49v20.68h-9.08v-18.72c0-3.07-.68-5.42-2.05-7.06-1.37-1.64-3.33-2.46-5.89-2.46-1.39,0-2.68.25-3.88.76-1.2.5-2.23,1.21-3.09,2.11-.86.9-1.54,1.98-2.02,3.21-.48,1.24-.72,2.6-.72,4.07v18.09h-9.08v-18.72c0-3.07-.68-5.42-2.05-7.06-1.37-1.64-3.33-2.46-5.89-2.46-1.39,0-2.68.25-3.88.76-1.2.5-2.23,1.21-3.09,2.11-.86.9-1.54,1.98-2.02,3.21-.48,1.24-.72,2.6-.72,4.07v18.09h-9.08V9.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.57,22.18c.29-2.27,1.02-4.26,2.17-5.96,1.15-1.7,2.57-3.11,4.25-4.22,1.68-1.11,3.55-1.95,5.61-2.52s4.16-.85,6.3-.85c2.27,0,4.51.33,6.71.98,2.21.65,4.16,1.61,5.86,2.87,1.7,1.26,3.08,2.84,4.13,4.73,1.05,1.89,1.58,4.1,1.58,6.62v21.12h-9.08v-5.48h-.19c-1.3,2.06-3.28,3.63-5.93,4.7-2.65,1.07-5.53,1.61-8.64,1.61-4.33,0-7.72-.97-10.18-2.9-2.46-1.93-3.69-4.58-3.69-7.94s1.25-5.79,3.75-7.53c2.5-1.74,6.19-2.62,11.06-2.62h13.81v-.82c0-1.26-.26-2.36-.79-3.31s-1.23-1.74-2.11-2.4c-.88-.65-1.88-1.13-2.99-1.45-1.11-.31-2.26-.47-3.44-.47-1.01,0-2,.12-2.96.35-.97.23-1.86.59-2.68,1.07-.82.48-1.52,1.09-2.11,1.83-.59.74-1.01,1.61-1.26,2.62h-9.2ZM187.58,34.15c0,1.47.69,2.63,2.08,3.47,1.39.84,3.28,1.26,5.67,1.26,1.72,0,3.3-.22,4.73-.66,1.43-.44,2.67-1.04,3.72-1.8,1.05-.76,1.87-1.64,2.46-2.65.59-1.01.88-2.1.88-3.28v-.38h-12.61c-4.62,0-6.93,1.35-6.93,4.03Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.38,37.49l21.12-21.11.63.08h-20.74v-7.46h31.21v7.19l-20.68,21.36v-.06h20.68v7.44h-32.22v-7.44Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.8,
    y: 9.01,
    width: 9.08,
    height: 35.92,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.88,28.47c0-1.68.09-3.63.64-5.05.55-1.41,1.32-2.64,2.3-3.67.98-1.03,2.16-1.83,3.53-2.41,1.37-.58,2.84-.86,4.42-.86,2.01-.01,1.85-.02,3.27-.02l.04-7.45h-1.74c-3.26,0-6.12.86-8.56,2.28-2.45,1.41-4.34,3.49-5.68,6.22",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.66,37.93h0c-2.01,0-3.64,1.63-3.64,3.64h0c0,2.01,1.63,3.64,3.64,3.64h0c2.01,0,3.64-1.63,3.64-3.64h0c0-2.01-1.63-3.64-3.64-3.64ZM41.66,44.58h0c-1.66,0-3.01-1.35-3.01-3.01s1.35-3.01,3.01-3.01h0c1.66,0,3.01,1.35,3.01,3.01s-1.35,3.01-3.01,3.01Z",
    fill: "#57aeed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.05,39.88h2.01c.41,0,.72.08.94.25.22.17.33.45.33.83,0,.3-.06.53-.19.69-.13.16-.32.27-.57.33l.93,1.18h0s-.83.01-.83.01l-.84-1.15h-1.08v1.15h-.69v-3.3ZM42.04,41.52c.2,0,.34-.04.44-.12.1-.08.15-.22.15-.43,0-.1-.01-.19-.04-.26s-.06-.12-.11-.17c-.05-.04-.11-.07-.18-.09s-.16-.03-.26-.03h-1.3v1.09h1.3Z",
    fill: "#57aeed"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.76c7df3f7d339656b924ddeb49089c22.svg";
export { ForwardRef as ReactComponent };